import React, { ReactNode, useMemo, useState } from 'react';

import { AutoComplete } from 'antd';
import classNames from 'classnames';

// phần custom lại AutoComplete theo UI input gốc và kết hợp đc với RHF
const CustomAutoCompleteField = ({
  value,
  onChange,
  onBlur,
  optionsAutoComplete,
  isAutoComplete,
  placementAutoComplete,
  onSelect,
  disable,
  allowClear,
  type,
  placeHolder,
  min,
  max,
  onFocus,
  inputRef, // Lấy ref từ RHF truyền xuống
  serverSearch,
  loading
}: any) => {
  // tuỳ biến riêng AutoComplete
  // Cờ nhận biết user đang gõ text hay chỉ vừa click focus vào
  const [isTyping, setIsTyping] = useState(false);

  // Memoize options để tối ưu performance nếu mảng options lớn (hàng ngàn xe/sensor)
  const formattedOptions = useMemo(() => {
    return optionsAutoComplete?.map(item => (typeof item === 'string' ? { value: item } : item)) || [];
  }, [optionsAutoComplete]);

  if (!isAutoComplete) return null; // Hoặc render input thường tùy logic

  return (
    <AutoComplete
      placement={placementAutoComplete || 'bottomLeft'}
      className="w-full"
      dropdownStyle={{ zIndex: 9999 }}
      options={formattedOptions}
      value={value || ''}
      onChange={val => {
        setIsTyping(true); // Ghi nhận user đang gõ phím hoặc thay đổi text
        onChange(val);
      }}
      onSelect={selectedValue => {
        setIsTyping(false); // Chọn xong thì tắt cờ, để lần focus sau bung full options
        onChange(selectedValue);
        if (onSelect) onSelect(selectedValue);
      }}
      filterOption={(inputValue, option) => {
        if (!option || !option.value) return false;

        if (!option || !option.value) return false;
        if (serverSearch) return true; // server đã lọc, hiển thị hết

        // CỐT LÕI: Nếu user không ở trạng thái gõ (tức là vừa click/focus vào),
        // trả về true cho TẤT CẢ các options để hiển thị danh sách đầy đủ.
        if (!isTyping) return true;

        // Nếu đang gõ, lọc bình thường theo keyword
        return option.value.toString().toLowerCase().includes(inputValue.toLowerCase());
      }}
      notFoundContent={loading ? 'Đang tìm...' : undefined}
      disabled={disable}
      allowClear={allowClear ?? true}
      onDropdownVisibleChange={open => {
        // Reset lại cờ nếu dropdown đóng
        if (!open) setIsTyping(false);
      }}
    >
      <input
        ref={inputRef}
        type={type || 'text'}
        spellCheck="false"
        style={{ fontFamily: 'Roboto', fontSize: '13px' }}
        autoComplete="off"
        placeholder={placeHolder}
        min={min}
        max={max}
        onFocus={e => {
          setIsTyping(false); // Ép hiển thị toàn bộ options ngay khi focus
          if (onFocus) onFocus(true);
        }}
        onBlur={() => {
          setIsTyping(false);
          if (onBlur) onBlur(false);
        }}
        className={classNames(
          disable && 'cursor-not-allowed text-gray-500 bg-gray-300',
          'bg-gray-100/40 appearance-none border border-gray-300 rounded-sm w-full py-1.5 px-2 text-black leading-tight focus:outline-none focus:bg-white focus:border-[#0D8BC3]'
        )}
      />
    </AutoComplete>
  );
};

export default CustomAutoCompleteField;

// nếu cần dùng ngoài RHF chỉ cần khai báo riêng dùng state react QL
// import React, { useState, useRef } from 'react';
// // import CustomAutoCompleteField từ đường dẫn của

// const NormalSearchComponent: React.FC = () => {
//   // 1. Khởi tạo state để lưu giá trị của input
//   const [searchValue, setSearchValue] = useState<string>('');

//   // (Tùy chọn) Nếu cần ref để auto-focus hoặc thao tác DOM trực tiếp
//   const inputRef = useRef<HTMLInputElement>(null);

//   // Dữ liệu mẫu (có thể lấy từ API)
//   const vehicleOptions = [
//     { value: '51C-123.45', label: '51C-123.45 - Xe tải Hino' },
//     { value: '29B-678.90', label: '29B-678.90 - Xe khách Ford' },
//     { value: '60A-111.22', label: '60A-111.22 - Xe con Toyota' },
//   ];

//   return (
//     <div className="p-4 w-96">
//       <h3 className="mb-2 font-bold text-gray-700">Tìm kiếm xe (Không dùng RHF)</h3>

//       <CustomAutoCompleteField
//         isAutoComplete={true}
//         // 2. Truyền state và hàm cập nhật state vào value và onChange
//         value={searchValue}
//         onChange={(val: string) => setSearchValue(val)}

//         // 3. Cung cấp mảng options
//         optionsAutoComplete={vehicleOptions}

//         // Các props giao diện khác
//         placeHolder="Nhập biển số xe..."
//         allowClear={true}
//         inputRef={inputRef} // Truyền ref nếu cần, không thì bỏ qua

//         // Bắt sự kiện khi user thực sự click chọn một option (chứ không chỉ gõ)
//         onSelect={(val) => {
//           console.log('User vừa chọn chính xác xe:', val);
//           // Gọi API tìm kiếm chi tiết, chuyển trang, v.v.
//         }}
//       />

//       <p className="mt-4 text-sm text-gray-500">
//         Giá trị hiện tại trong state: <span className="font-bold text-blue-600">{searchValue}</span>
//       </p>
//     </div>
//   );
// };

// export default NormalSearchComponent;
